// removed by extract-text-webpack-plugin
module.exports = {"container":"gridVideo-module_container_1_IOL","videoContainer":"gridVideo-module_videoContainer_24Vwl","videoLink":"gridVideo-module_videoLink_1Bqu4","video":"gridVideo-module_video_350t8","overlay":"gridVideo-module_overlay_1gzeX","itemActions":"gridVideo-module_itemActions_27pvf","titleContainer":"gridVideo-module_titleContainer_4p3d9","title":"gridVideo-module_title_27qO4","meta":"gridVideo-module_meta_1WKWO","price":"gridVideo-module_price_wYGD3","duration":"gridVideo-module_duration_2lmj6"};


//////////////////
// WEBPACK FOOTER
// ./client/components/itemCard/gridVideo.module.css
// module id = 1020
// module chunks = 1